
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        content: {
            type: Object,
            default: () => {},
        },
    },
    setup() {
        const isImage = (url: any) => {
            return (
                url.slice(-3) === 'jpg' ||
                url.slice(-4) === 'jpeg' ||
                url.slice(-3) === 'png' ||
                url.slice(-3) === 'bmp'
            )
        }
        const download = (content: any) => {
            if (content.url) {
                let url = content.url
                const index = url.indexOf(':')
                if (index !== 5) {
                    const url1 = url.replace('http', 'https')
                    window.open(url1)
                } else {
                    window.open(url)
                }
            }
        }
        return {
            isImage,
            download,
        }
    },
})
